import { render } from "./Appyoutopdown.vue?vue&type=template&id=22ecc821&scoped=true"
import script from "./Appyoutopdown.vue?vue&type=script&lang=js"
export * from "./Appyoutopdown.vue?vue&type=script&lang=js"

import "./Appyoutopdown.vue?vue&type=style&index=0&id=22ecc821&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ecc821"]])

export default __exports__